import React, { createContext, useContext, useState, ReactNode } from 'react';
import {
  ISortBy,
  SortByTitleDesc,
  SortByLastUpdateRecentFirst
} from '../../Models/sortby.model';

interface SortingContextType {
  sort: ISortBy;
  setSort: (sort: ISortBy) => void;
}

const SortingContext = createContext<SortingContextType | undefined>(undefined);

export const SortingProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const [sort, setSort] = useState<ISortBy>(SortByLastUpdateRecentFirst);

  return (
    <SortingContext.Provider value={{ sort, setSort }}>
      {children}
    </SortingContext.Provider>
  );
};

export const useSorting = () => {
  const context = useContext(SortingContext);
  if (!context) {
    throw new Error('useSorting must be used within a SortingProvider');
  }
  return context;
};
